import { createSlice } from "@reduxjs/toolkit";
import { getPlanDetails, getPlans, updatePlan } from "store/actions/subscriptionPlansSlice";

const initialState = {
  loading: false,
  isLoading: false,
  perPage: 50,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  plans: [],
  planDetails: {},
};

const plans = createSlice({
  name: "plans",
  initialState,
  reducers: {
    setSortedPlans: (state, action) => {
      state.plans = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPlans.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.plans = data || [];
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getPlans.rejected, (state, action) => {
        state.loading = false;
      });


    builder
      .addCase(getPlanDetails.pending, (state) => {
        state.loading = true;
        state.planDetails = {};
      })
      .addCase(getPlanDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.planDetails = data || {};
        }
      })
      .addCase(getPlanDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(updatePlan.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePlan.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updatePlan.rejected, (state, action) => {
        state.isLoading = false;
      });

  },
});

export default plans.reducer;

export const { setSortedPlans } = plans.actions;
